import React, { useState, useRef, useEffect } from 'react';
import { Dropdown, Tooltip, Button, message } from 'antd';
import { ReactSVG } from 'react-svg';
import { PlusCircleOutlined } from '@ant-design/icons';
import type { MenuProps, DropdownProps } from 'antd';
import JoinTeamModal from './conponents/JoinTeamModal'; //  加入团队弹窗
import { joinTenant } from '@/services/api/admin';
import { RESPONSE_CODES } from '@/utils/constants';
import { useModel } from '@umijs/max';


import styles from './index.less';
import { history } from 'umi';

interface TeamDropdownProps {
  menu: {
    items: Array<{
      key: string;
      icon: React.ReactNode;
      label: string;
      showManage?: boolean;
    }>;
    onClick: MenuProps['onClick'];
  };
  children: React.ReactNode;
  addNewTenantToList?: (newTenantInfo: any) => void; // 新增租户回调
}

const TeamDropdown: React.FC<TeamDropdownProps> = ({ menu, children, addNewTenantToList }) => {
  const [open, setOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false); // 控制弹出层显示
  const { initialState, setInitialState } = useModel('@@initialState');
  const userInfo = initialState?.currentUser || {};

  const handleOpenChange: DropdownProps['onOpenChange'] = (nextOpen) => {
    setOpen(nextOpen);
  };

  const handleModalOk = async (values: any) => {
    const params = {
      code: values.code,
      userId: userInfo.id,
    }
    const result = await joinTenant(params);
    if (result?.code === RESPONSE_CODES.SUCCESS) {
      const newTenantInfo = result?.data || {};
      // 判断 newTenantInfo 是否有值
      if (newTenantInfo && addNewTenantToList) {
        addNewTenantToList(newTenantInfo);
        message.success('加入团队成功');
      } else {
        console.warn('newTenantInfo 为空，未调用 addNewTenantToList');
      }
      return true;
    }


  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const dropdownMenuItems: MenuProps['items'] = [
    ...menu.items?.map((team) => ({
      key: team.key,
      label: <TeamItem team={team} />,
    })),
    {
      type: 'divider',
    },
    {
      key: 'joinTeam',
      label: (
        <Button
          type="link"
          block
          onClick={(e) => {
            e.stopPropagation(); // 阻止事件冒泡
            if (!isModalVisible) {
              setIsModalVisible(true); // 显示弹出层
            }
          }}
          className={styles.joinButton}
        >
          <PlusCircleOutlined />加入团队
        </Button>
      ),
    },
  ];
  return (
    <>
      <Dropdown
        menu={{
          items: dropdownMenuItems,
          onClick: (info) => {
            if (info.key === 'joinTeam') {
              // 如果点击的是“加入团队”，不执行其他逻辑
              return;
            }
            // 执行原有的 menu.onClick 逻辑
            menu.onClick(info);
          },
        }}
        onOpenChange={handleOpenChange}
        open={open}
        trigger={['hover']}
        placement="bottomRight"
        overlayClassName={styles.dropdownOverlay}
      >
        <div className={styles.dropdownTrigger}>{children}</div>
      </Dropdown>
      {/* 调用 CreateTeamModal */}
      {/* <CreateTeamModal
        visible={isModalVisible}
        onCancel={handleModalCancel}
        onOk={handleModalOk} /> */}
      <JoinTeamModal
        visible={isModalVisible}
        onCancel={handleModalCancel}
        onOk={handleModalOk} />
    </>
  );
};

// 单独封装一个 TeamItem 组件
const TeamItem: React.FC<{ team: { key: string; icon: React.ReactNode; label: string; showManage?: boolean } }> = ({ team }) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isOverflow, setIsOverflow] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      const { scrollWidth, offsetWidth } = textRef.current;
      setIsOverflow(scrollWidth > offsetWidth); // 判断是否超出
    }
  }, [team.label]);

  return (
    <div className={styles.teamRow}>
      {team.icon && <span className={styles.teamIcon}>{team.icon}</span>}
      <Tooltip title={isOverflow ? team.label : null} placement="right">
        <span
          ref={textRef}
          className={styles.teamName}
          style={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            maxWidth: '150px', // 设置最大宽度
            display: 'inline-block',
          }}
        >
          {team.label}
        </span>
      </Tooltip>
      {/* {team.showManage && (
        <a href={`/team/manage/${team.key}`} className={styles.manageLink}>
          团队管理
        </a>
      )} */}
    </div>
  );
};

export default TeamDropdown;